<template>
  <vs-popup
    title="POLITIQUE DE CONFIDENTIALITE"
    :active.sync="isPromptActiveLocal" fullscreen
  >
    <!-- <p style="text-align: center">
      <strong
        ><span style="font-family: Calibri; font-weight: bold; font-size: 15px"
          >POLITIQUE DE CONFIDENTIALITE</span
        ></strong
      >
    </p> -->
    <p style="text-align: center">
      <strong
        ><span style="font-family: Calibri; font-weight: bold; font-size: 15px"
          >&nbsp;</span
        ></strong
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <span style="font-family: Calibri; font-size: 15px"
        >Dans le cadre de notre activit&eacute; d&rsquo;Op&eacute;rateur de
        T&eacute;l&eacute;phonie mobile et ses activit&eacute;s commerciales
        d&eacute;riv&eacute;es, nous sommes amen&eacute;s &agrave; traiter des
        informations vous concernant. Par exemple en naviguant sur notre site
        Internet ou nos applications mobiles et num&eacute;riques, en cliquant
        sur un lien publicitaire que nous vous pr&eacute;sentons, vous nous
        transmettez des informations dont certaines sont de nature &agrave; vous
        identifier (&laquo;&nbsp;donn&eacute;es
        personnelles&nbsp;&raquo;).</span
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <span style="font-family: Calibri; font-size: 15px"
        >La pr&eacute;sente Politique de confidentialit&eacute; vous informe de
        la mani&egrave;re dont nous recueillons et traitons vos donn&eacute;es
        personnelles dans le strict respect de la loi n&deg; 2017-20 du 20 avril
        2018 portant code du num&eacute;rique en R&eacute;publique du
        B&eacute;nin et en conformit&eacute; avec la politique
        g&eacute;n&eacute;rale du groupe MTN.</span
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <span style="font-family: Calibri; font-size: 15px"
        >Nous vous invitons &agrave; la lire attentivement et marquer votre
        accord.</span
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <span style="font-family: Calibri; font-size: 15px">&nbsp;</span>
    </p>
    <p>
      <span
        style="font-family: Calibri; font-weight: bold; font-size: 11, 0000pt"
        >1-&nbsp;</span
      ><strong
        ><span style="font-family: Calibri; font-size: 11, 0000pt"
          >Pour quelles raisons collectons-nous des donn&eacute;es ?</span
        ></strong
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <span style="font-family: Calibri; font-size: 15px"
        >Nous collectons des donn&eacute;es personnelles pour les raisons
        principales suivantes :</span
      >
    </p>
    <ul>
      <li>
        <span style="font-family: Calibri; font-size: 11, 0000pt"
          >Faciliter l&apos;utilisation du Site, et enrichir nos relations et
          interactions avec nos utilisateurs.</span
        >
      </li>
      <li>
        <span style="font-family: Calibri; font-size: 11, 0000pt"
          >R&eacute;aliser des statistiques pr&eacute;cises pour des actions
          cibl&eacute;es.</span
        >
      </li>
      <li>
        <span style="font-family: Calibri; font-size: 11, 0000pt"
          >Concevoir et proposer des offres promotionnelles
          personnalis&eacute;es &agrave; nos utilisateurs&nbsp;</span
        >
      </li>
    </ul>
    <p>
      <strong
        ><u
          ><span
            style="
              font-family: Calibri;
              text-decoration: underline;
              font-size: 15px;
            "
            >Important&nbsp;:</span
          ></u
        ></strong
      ><span style="font-family: 'Times New Roman'; font-size: 16px"
        >&nbsp;</span
      ><strong
        ><span style="font-family: Calibri; font-size: 15px"
          >Exclusion de toute donn&eacute;e sensible</span
        ></strong
      >
    </p>
    <p style="text-align: justify">
      <span style="font-family: 'Times New Roman'; font-size: 16px"
        >Nous ne collectons aucune donn&eacute;e sensible vous concernant. Sont
        consid&eacute;r&eacute;es comme des donn&eacute;es sensibles&nbsp;:
        l&rsquo;origine raciale ou ethnique, les opinions politiques, les
        croyances religieuses ou philosophiques, l&rsquo;adh&eacute;sion
        &agrave; un syndicat, les donn&eacute;es relatives &agrave; la
        sant&eacute; ou l&rsquo;orientation sexuelle. Si de telles informations
        nous &eacute;taient d&rsquo;une mani&egrave;re ou d&rsquo;une autre
        communiqu&eacute;es, elles seront supprim&eacute;es.</span
      >
    </p>
    <p
      style="
        margin-bottom: 0, 0000pt;
        margin-left: 36, 0000pt;
        text-align: justify;
      "
    >
      <span style="font-family: Calibri; font-size: 15px">&nbsp;</span>
    </p>
    <p
      style="
        margin-bottom: 0, 0000pt;
        margin-left: 36, 0000pt;
        text-align: justify;
      "
    >
      <span style="font-family: Calibri; font-size: 15px">&nbsp;</span>
    </p>
    <p>
      <span
        style="font-family: Calibri; font-weight: bold; font-size: 11, 0000pt"
        >2-&nbsp;</span
      ><strong
        ><span style="font-family: Calibri; font-size: 11, 0000pt"
          >Quelles personnes collectent des donn&eacute;es vous concernant
          ?</span
        ></strong
      >
    </p>
    <p style="margin-bottom: 0, 0000pt">
      <span style="font-family: Calibri; font-size: 15px"
        >La collecte et le traitement de donn&eacute;es personnelles via le Site
        mtn.bj , et pour les besoins des Services sont effectu&eacute;s sous la
        responsabilit&eacute; de la soci&eacute;t&eacute; Spacetel-Benin (MTN
        B&eacute;nin),&nbsp;</span
      ><span style="font-family: Calibri; font-size: 15px"
        >Soci&eacute;t&eacute; Anonyme avec Conseil d&rsquo;Administration au
        capital de 892 000 000 F CFA, dont le si&egrave;ge est sis &agrave;
        Cotonou, 360 Boulevard de la Marina, Zone a&eacute;roportuaire, 01 BP
        &nbsp;5293 Cotonou, immatricul&eacute;e au Registre du Commerce et du
        Cr&eacute;dit Mobilier sous le num&eacute;ro RB/COT/07-B-1137.</span
      ><span style="font-family: Calibri; font-size: 15px">&nbsp;</span>
    </p>
    <p style="margin-bottom: 0, 0000pt">
      <span style="font-family: Calibri; font-size: 15px">&nbsp;</span>
    </p>
    <p style="margin-bottom: 0, 0000pt">
      <span style="font-family: Calibri; font-size: 15px">&nbsp;</span
      ><span style="font-family: Calibri; font-size: 15px">&nbsp;</span>
    </p>
    <p>
      <span
        style="font-family: Calibri; font-weight: bold; font-size: 11, 0000pt"
        >3-&nbsp;</span
      ><strong
        ><span style="font-family: Calibri; font-size: 11, 0000pt"
          >Combien de temps ces informations sont-elles conserv&eacute;es
          ?</span
        ></strong
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <span style="font-family: Calibri; font-size: 15px"
        >D&apos;une mani&egrave;re g&eacute;n&eacute;rale, vos donn&eacute;es
        personnelles sont conserv&eacute;es pendant une dur&eacute;e conforme
        aux dispositions l&eacute;gales ou en base active, le temps
        n&eacute;cessaire &agrave; la gestion des Services souscrits, et tant
        que votre compte utilisateur reste actif. Certaines de vos
        donn&eacute;es peuvent &ecirc;tre conserv&eacute;es apr&egrave;s la
        fermeture de votre compte pour assurer la gestion de demandes ou litiges
        en cours.</span
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <span style="font-family: Calibri; font-size: 15px"
        >En tout &eacute;tat de cause, nous r&eacute;visons
        r&eacute;guli&egrave;rement les informations que nous d&eacute;tenons,
        notamment si vous avez fait usage d&rsquo;un droit de modification ou
        d&rsquo;effacement, nous les supprimerons de fa&ccedil;on
        s&eacute;curis&eacute;e.</span
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <span style="font-family: Calibri; font-size: 15px">&nbsp;</span>
    </p>
    <p>
      <span
        style="font-family: Calibri; font-weight: bold; font-size: 11, 0000pt"
        >4-&nbsp;</span
      ><strong
        ><span style="font-family: Calibri; font-size: 11, 0000pt"
          >Comment est assur&eacute;e la s&eacute;curit&eacute; de mes
          donn&eacute;es personnelles ?</span
        ></strong
      >
    </p>
    <p>
      <span
        style="
          font-family: 'Times New Roman';
          color: rgb(199, 82, 82);
          font-size: 16px;
        "
        >En application de la politique de confidentialit&eacute; en ses section
        8.7 (mesures de s&eacute;curit&eacute;) et 8.8 ( op&eacute;rateurs
        tiers/processeurs),&nbsp;</span
      ><span style="font-family: 'Times New Roman'; font-size: 16px"
        >&nbsp;En tant que responsable de traitements</span
      ><span
        style="
          font-family: 'Times New Roman';
          color: rgb(0, 0, 0);
          font-size: 16px;
        "
        >, nous&nbsp;</span
      ><span style="font-family: 'Times New Roman'; font-size: 16px"
        >mettons en &oelig;uvre des mesures destin&eacute;es &agrave; garantir
        la s&eacute;curit&eacute; du Site, et de ces Services et prot&eacute;ger
        ainsi vos donn&eacute;es personnelles contre tout acc&egrave;s par des
        tiers non autoris&eacute;s., nous mettons en &oelig;uvre des mesures
        techniques et organisationnelles appropri&eacute;es conform&eacute;ment
        aux dispositions l&eacute;gales applicables, pour prot&eacute;ger vos
        donn&eacute;es personnelles contre l&rsquo;alt&eacute;ration, la perte
        accidentelle ou illicite, l&rsquo;utilisation, la divulgation ou
        l&rsquo;acc&egrave;s non autoris&eacute;, et notamment&nbsp;:</span
      >
    </p>
    <ul>
      <li>
        <em
          ><span style="font-family: Calibri; font-size: 11, 0000pt"
            >L&rsquo;existence d&rsquo;une cellule consacr&eacute;e &agrave; la
            s&eacute;curit&eacute; des syst&egrave;mes
            d&rsquo;information&nbsp;;</span
          ></em
        >
      </li>
      <li>
        <em
          ><span style="font-family: Calibri; font-size: 11, 0000pt"
            >La sensibilisation aux exigences de confidentialit&eacute; de nos
            collaborateurs amen&eacute;s &agrave; acc&eacute;der&nbsp;</span
          ></em
        ><em
          ><span style="font-family: Calibri; font-size: 11, 0000pt"
            ><br /></span></em
        ><em
          ><span style="font-family: Calibri; font-size: 11, 0000pt"
            >&agrave; vos donn&eacute;es personnelles&nbsp;;</span
          ></em
        >
      </li>
      <li>
        <em
          ><span style="font-family: Calibri; font-size: 11, 0000pt"
            >La s&eacute;curisation de l&rsquo;acc&egrave;s &agrave; nos locaux
            et &agrave; nos plates-formes informatiques&nbsp;;</span
          ></em
        >
      </li>
      <li>
        <em
          ><span style="font-family: Calibri; font-size: 11, 0000pt"
            >La mise en &oelig;uvre d&rsquo;une politique g&eacute;n&eacute;rale
            de s&eacute;curit&eacute; informatique de
            l&rsquo;entreprise&nbsp;;</span
          ></em
        >
      </li>
      <li>
        <em
          ><span style="font-family: Calibri; font-size: 11, 0000pt"
            >La s&eacute;curisation de l&rsquo;acc&egrave;s, du partage et du
            transfert des donn&eacute;es&nbsp;;</span
          ></em
        >
      </li>
    </ul>
    <p style="margin-bottom: 0, 0000pt">
      <span style="font-family: Calibri; font-size: 15px">&nbsp;</span>
    </p>
    <p>
      <span
        style="font-family: Calibri; font-weight: bold; font-size: 11, 0000pt"
        >5-&nbsp;</span
      ><strong
        ><span style="font-family: Calibri; font-size: 11, 0000pt"
          >Quelles donn&eacute;es collectons-nous ?</span
        ></strong
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <strong
        ><span style="font-family: Calibri; font-weight: bold; font-size: 15px"
          >Des donn&eacute;es collect&eacute;es automatiquement sur votre
          navigation</span
        ></strong
      ><strong
        ><span
          style="
            font-family: Arial;
            color: rgb(50, 56, 57);
            font-weight: bold;
            font-size: 16px;
          "
          >:</span
        ></strong
      ><span style="font-family: Arial; color: rgb(50, 56, 57); font-size: 16px"
        >&nbsp;</span
      ><span style="font-family: Calibri; font-size: 15px"
        >il s&apos;agit des informations qui sont rattach&eacute;es &agrave;
        votre navigateur (comme vos activit&eacute;s en ligne sur le Site, vos
        visites, les pages vues, l&apos;adresse IP et votre
        num&eacute;ro.).&nbsp;</span
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <span style="font-family: Calibri; font-size: 15px">&nbsp;</span>
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <strong
        ><span style="font-family: Calibri; font-weight: bold; font-size: 15px"
          >&nbsp;</span
        ></strong
      >
    </p>
    <p>
      <span style="font-family: Calibri; font-size: 11, 0000pt"
        ><strong>6</strong>-&nbsp;</span
      ><strong
        ><span style="font-family: Calibri; font-size: 11, 0000pt"
          >Pour quelles finalit&eacute;s utilisons &ndash;nous vos
          donn&eacute;es ?&nbsp;</span
        ></strong
      >
    </p>
    <p>
      <strong
        ><span style="font-family: Calibri; font-size: 11, 0000pt"
          >&nbsp; &nbsp; Stocker et /ou acc&eacute;der &agrave; des informations
          sur un terminal.</span
        ></strong
      >
    </p>
    <p style="margin-bottom: 0, 0000pt">
      <span style="font-family: Calibri; font-size: 15px"
        >Le header enrichi l&rsquo;identifiant de votre terminal ou autres
        informations peuvent &ecirc;tre stock&eacute;es ou consult&eacute;es sur
        votre terminal pour les finalit&eacute;s qui vous sont
        pr&eacute;sent&eacute;es.</span
      >
    </p>
    <p style="margin-bottom: 0, 0000pt">
      <span style="font-family: Calibri; font-size: 15px">&nbsp;</span>
    </p>
    <p style="margin-bottom: 0, 0000pt">
      <span style="font-family: Calibri; font-size: 15px">&nbsp;</span
      ><span style="font-family: Wingdings; font-size: 11, 0000pt"
        >&nbsp; &nbsp;&nbsp;</span
      ><strong
        ><span style="font-family: Calibri; font-size: 11, 0000pt"
          >Cr&eacute;er un profil personnalis&eacute; de publicit&eacute;s</span
        ></strong
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <span style="font-family: Calibri; font-size: 15px"
        >Un profil peut &ecirc;tre cr&eacute;&eacute; sur vous et sur vos
        centres d&rsquo;int&eacute;r&ecirc;t pour vous pr&eacute;senter des
        publicit&eacute;s personnalis&eacute;es susceptibles de vous
        int&eacute;resser.&nbsp;</span
      ><span
        style="font-family: Calibri; color: rgb(199, 82, 82); font-size: 15px"
        >Mais nous vous laissons toujours le choix d&rsquo;accepter ou de
        refuser de telles communications</span
      >
    </p>
    <p style="margin-bottom: 0, 0000pt">
      <span
        style="font-family: Calibri; color: rgb(199, 82, 82); font-size: 15px"
        >&nbsp;</span
      >
    </p>
    <p>
      <span style="font-family: Wingdings; font-size: 11, 0000pt"
        >&nbsp; &nbsp;&nbsp;</span
      ><strong
        ><span style="font-family: Calibri; font-size: 11, 0000pt"
          >Cr&eacute;er un profil pour afficher un contenu
          personnalis&eacute;</span
        ></strong
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <span style="font-family: Calibri; font-size: 15px"
        >Un profil peut &ecirc;tre cr&eacute;&eacute; sur vous et sur vos
        centres d&rsquo;int&eacute;r&ecirc;t pour vous pr&eacute;senter du
        contenu personnalis&eacute; susceptible de vous int&eacute;resser
        .</span
      >
    </p>
    <p style="margin-bottom: 0, 0000pt">
      <span style="font-family: Calibri; font-size: 15px">&nbsp;</span>
    </p>
    <p>
      <span style="font-family: Wingdings; font-size: 11, 0000pt"
        >&nbsp; &nbsp;&nbsp;</span
      ><strong
        ><span style="font-family: Calibri; font-size: 11, 0000pt"
          >D&eacute;velopper et am&eacute;liorer les produits</span
        ></strong
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <span style="font-family: Calibri; font-size: 15px"
        >Vos donn&eacute;es peuvent &ecirc;tre utilis&eacute;es pour
        am&eacute;liorer les syst&egrave;mes et logiciels existants et pour
        d&eacute;velopper de nouveaux produits.</span
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <span style="font-family: Calibri; font-size: 15px"
        >Exploiter des &eacute;tudes du march&eacute; afin de
        g&eacute;n&eacute;rer des donn&eacute;es d&rsquo;audience.</span
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <span style="font-family: Calibri; font-size: 15px"
        >Les &eacute;tudes de march&eacute; peuvent servir &agrave; en apprendre
        davantage sur les audiences qui visitent des sites / utilisent des
        applications et voient des publicit&eacute;s.</span
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <span style="font-family: Calibri; font-size: 15px">&nbsp;</span>
    </p>
    <p>
      <span style="font-family: Wingdings; font-size: 11, 0000pt"
        >&nbsp; &nbsp;&nbsp;</span
      ><strong
        ><span style="font-family: Calibri; font-size: 11, 0000pt"
          >Mesurer la performance des publicit&eacute;s</span
        ></strong
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <span style="font-family: Calibri; font-size: 15px"
        >La performance et l&rsquo;efficacit&eacute; des publicit&eacute;s que
        vous voyez ou avec lesquelles vous interagissez peuvent &ecirc;tre
        mesur&eacute;es.</span
      >
    </p>
    <p style="margin-bottom: 0, 0000pt">
      <span style="font-family: Calibri; font-size: 15px">&nbsp;</span>
    </p>
    <p style="margin-bottom: 0, 0000pt">
      <span style="font-family: Wingdings; font-size: 11, 0000pt"
        >&nbsp; &nbsp;&nbsp;</span
      ><strong
        ><span style="font-family: Calibri; font-size: 11, 0000pt"
          >Mesurer la performance du contenu</span
        ></strong
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <span style="font-family: Calibri; font-size: 15px"
        >La performance et l&rsquo;efficacit&eacute; du contenu que vous voyez
        ou avec lequel vous interagissez peuvent &ecirc;tre
        mesur&eacute;es.</span
      >
    </p>
    <p style="margin-bottom: 0, 0000pt">
      <span style="font-family: Calibri; font-size: 15px">&nbsp;</span>
    </p>
    <p>
      <span style="font-family: Wingdings; font-size: 11, 0000pt"
        >&nbsp; &nbsp;&nbsp;</span
      ><strong
        ><span style="font-family: Calibri; font-size: 11, 0000pt"
          >S&eacute;lectionner des publicit&eacute;s standard</span
        ></strong
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <span style="font-family: Calibri; font-size: 15px"
        >Les publicit&eacute;s peuvent vous &ecirc;tre pr&eacute;sent&eacute;es
        en fonction du contenu &eacute;ditorial que vous consultez, de
        l&rsquo;application que vous utilisez, de votre localisation
        approximative, ou de votre type de terminal.</span
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <span style="font-family: Calibri; font-size: 15px">&nbsp;</span>
    </p>
    <p>
      <span style="font-family: Wingdings; font-size: 11, 0000pt"
        >&nbsp; &nbsp;&nbsp;</span
      ><strong
        ><span style="font-family: Calibri; font-size: 11, 0000pt"
          >S&eacute;lectionner des publicit&eacute;s
          personnalis&eacute;es.</span
        ></strong
      >
    </p>
    <p style="text-align: justify; line-height: 200%">
      <span style="font-family: Calibri; font-size: 15px"
        >Des publicit&eacute;s personnalis&eacute;es peuvent vous &ecirc;tre
        pr&eacute;sent&eacute;es sur la base d&rsquo;un profil
        cr&eacute;&eacute; sur vous.</span
      >
    </p>
    <p>
      <span style="font-family: Wingdings; font-size: 11, 0000pt"
        >&nbsp; &nbsp;&nbsp;</span
      ><strong
        ><span style="font-family: Calibri; font-size: 11, 0000pt"
          >Analyser activement les caract&eacute;ristiques du terminal pour
          l&rsquo;identification.</span
        ></strong
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <span style="font-family: Calibri; font-size: 15px"
        >Votre terminal peut &ecirc;tre identifi&eacute; sur la base d&rsquo;une
        analyse de la combinaison unique de caract&eacute;ristiques de votre
        terminal.</span
      >
    </p>
    <p style="margin-bottom: 0, 0000pt">
      <span style="font-family: Calibri; font-size: 15px">&nbsp;</span>
    </p>
    <p>
      <span style="font-family: Wingdings; font-size: 11, 0000pt"
        >&nbsp; &nbsp;&nbsp;</span
      ><strong
        ><span style="font-family: Calibri; font-size: 11, 0000pt"
          >Utiliser des donn&eacute;es de g&eacute;olocalisation
          pr&eacute;cises.</span
        ></strong
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <span style="font-family: Calibri; font-size: 15px"
        >Vos donn&eacute;es de g&eacute;olocalisation pr&eacute;cises peuvent
        &ecirc;tre utilis&eacute;es &agrave; l&rsquo;appui d&rsquo;une ou de
        Plusieurs finalit&eacute;s. Cela signifie que votre localisation peut
        &ecirc;tre pr&eacute;cise &agrave; Plusieurs m&egrave;tres
        pr&egrave;s.</span
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <span style="font-family: Calibri; font-size: 15px">&nbsp;</span>
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <span style="font-family: Calibri; font-size: 15px"
        >En acc&eacute;dant aux pages de ce site, vous autorisez
        &eacute;galement ce site &agrave; r&eacute;aliser les traitements de
        donn&eacute;es suivants: assurer la s&eacute;curit&eacute;,
        pr&eacute;venir la fraude et d&eacute;boguer, diffuser techniquement les
        publicit&eacute;s ou le contenu, mettre en correspondance et combiner
        des sources de donn&eacute;es hors ligne, recevoir et utiliser des
        caract&eacute;ristiques d&rsquo;identification d&rsquo;appareil
        envoy&eacute;es automatiquement et relier diff&eacute;rents
        terminaux.</span
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <span style="font-family: Calibri; font-size: 15px">&nbsp;</span>
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify">
      <span style="font-family: Calibri; font-size: 15px">&nbsp;</span>
    </p>
    <p>
      <span
        style="font-family: Calibri; font-weight: bold; font-size: 11, 0000pt"
        >7-&nbsp;</span
      ><strong
        ><span style="font-family: Calibri; font-size: 11, 0000pt"
          >Information de vos droits sur les donn&eacute;es collect&eacute;es et
          trait&eacute;es ?</span
        ></strong
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify; line-height: 200%">
      <span style="font-family: Calibri; font-size: 15px"
        >MTN respecte votre droit &agrave; la vie priv&eacute;e. Cette politique
        de confidentialit&eacute; (ainsi que tout document ou note
        d&rsquo;information redirigeant vers cette politique) vous tient
        inform&eacute;s sur la mani&egrave;re dont sont trait&eacute;es les
        donn&eacute;es personnelles recueillies dans le cadre de navigation du
        site de MTN B&eacute;nin ainsi que des services proposes au travers du
        site, comme l&rsquo;opportunit&eacute; de t&eacute;l&eacute;charger et
        d&rsquo;utiliser l&rsquo;application mobile de MTN (ci-apr&egrave;s
        MyMTN), la possibilit&eacute; d&rsquo;acheter en ligne des articles tels
        que des Smartphones, kit de connection, routeurs et autres
        (ci-apr&egrave;s la E-Boutique).</span
      >
    </p>
    <p style="margin-bottom: 0, 0000pt; text-align: justify; line-height: 200%">
      <br />
    </p>
    <p>
      <span style="font-family: Wingdings; font-size: 11, 0000pt"
        >&nbsp; &nbsp;</span
      ><strong
        ><span style="font-family: Calibri; font-size: 11, 0000pt"
          >Vos droits en mati&egrave;re de donn&eacute;es personnelles</span
        ></strong
      >
    </p>
    <p
      style="
        margin-bottom: 0, 0000pt;
        margin-left: 72, 0000pt;
        text-align: justify;
      "
    >
      <span style="font-family: Calibri; font-size: 15px"
        >MTN vous informe que vous pouvez librement lui &eacute;crire aux
        adresses&nbsp;</span
      ><a href="mailto:serviceclient@mtn.bj"
        ><u
          ><span
            style="
              font-family: Calibri;
              color: rgb(5, 99, 193);
              text-decoration: underline;
            "
            >serviceclient@mtn.bj</span
          ></u
        ></a
      ><span style="font-family: Calibri; font-size: 15px">&nbsp;et&nbsp;</span
      ><a href="mailto:info@mtn.bj"
        ><u
          ><span
            style="
              font-family: Calibri;
              color: rgb(5, 99, 193);
              text-decoration: underline;
            "
            >info@mtn.bj</span
          ></u
        ></a
      ><span style="font-family: Calibri; font-size: 15px">&nbsp;</span
      ><span style="font-family: Calibri; font-size: 15px"
        >pour vous opposer au traitement de vos donn&eacute;es collect&eacute;es
        via le site. Vous pouvez &eacute;galement solliciter leur rectification,
        leurs mises &agrave; jour ainsi que leurs suppression. Sans que cela ne
        restreigne l&rsquo;utilisation de la carte Sim concern&eacute;e tant que
        d&rsquo;autres motifs isol&eacute;s d&rsquo;incapacit&eacute; de
        communiquer avec la carte Sim (coupure pour d&eacute;faut
        d&rsquo;enregistrement) ne soient d&rsquo;actualit&eacute;</span
      >
    </p>
    <p
      style="
        margin-bottom: 0, 0000pt;
        margin-left: 72, 0000pt;
        text-align: justify;
      "
    >
      <br />
    </p>
    <p>
      <span style="font-family: Wingdings; font-size: 11, 0000pt"
        >&nbsp; &nbsp;</span
      ><strong
        ><span style="font-family: Calibri; font-size: 11, 0000pt"
          >Vos droits en mati&egrave;re d&rsquo;opposition aux sollicitations
          commerciales&nbsp;</span
        ></strong
      >
    </p>
    <p>
      <span style="font-family: Calibri; font-size: 15px"
        >Nous sommes susceptibles d&rsquo;utiliser vos coordonn&eacute;es dans
        le cadre de sollicitations commerciales, en conformit&eacute; avec la
        loi applicable et les clauses de la pr&eacute;sente politique de
        confidentialit&eacute;. Vous pouvez &agrave; tout moment vous opposer
        &agrave; ces sollicitations, selon des modalit&eacute;s qui
        d&eacute;pendent du canal de communication que nous utilisons pour vous
        les adresser.</span
      >
    </p>
    <p>
      <span style="font-family: Calibri; font-size: 15px"
        >Avant de r&eacute;pondre &agrave; vos demandes, nous sommes
        susceptibles de v&eacute;rifier votre identit&eacute; et/ou vous
        demander de nous fournir davantage d&rsquo;informations pour y
        r&eacute;pondre. Nous nous efforcerons de donner suite &agrave; votre
        demande dans un d&eacute;lai raisonnable et, en tout &eacute;tat de
        cause, dans les d&eacute;lais fix&eacute;s par la l&eacute;gislation en
        vigueur.</span
      >
    </p>
  </vs-popup>
</template>

<script>
export default {
  name: "termsAndCondition",
  props: {
    isPromptActive: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    isPromptActive(val) {
      if (!val) return;
    },
  },
  computed: {
    isPromptActiveLocal: {
      get() {
        return this.isPromptActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closePrompt");
        }
      },
    },
  },
  data: () => ({}),
  methods: {},
};
</script>

<style scoped>
</style>
